import React, { useCallback, useEffect, useContext } from 'react';

import cookie from 'react-cookies';
import { NotificationManager } from 'react-notifications';
import { usePlaidLink } from 'react-plaid-link';

import TenantConfig from '../../config';

/** context */
import { UserContext } from '../../context/UserContext';
import { useRudder } from '../../hooks/rudder';

/** service */
import { updateApplication } from '../../service/api';

const CustomPlaidLink = ({
  token,
  handleContinue,
  setPlaidState,
  setLoading,
  receivedRedirectUri,
  setError,
  buttonText,
  buttonClassName,
  closeTimes,
  setCloseTimes,
}) => {
  const { setPlaidToken, updateAppData } = useContext(UserContext);
  const { errorEvent } = useRudder();

  const plaidNbOfRetries = TenantConfig?.manualBankAccount?.plaidNbOfRetries;

  const onSuccess = useCallback(
    async (public_token, metadata) => {
      // send public_token to server
      setPlaidToken(public_token);
      // setLoading(true);
      try {
        const res = await updateApplication([
          {
            itemType: 'PlaidTokenProperty',
            dataType: 'plaidtoken',
            name: 'plaidToken',
            value: {
              plaidLinkage: {
                publicToken: public_token,
                plaidNotLinkable: false,
              },
            },
          },
        ]);
        if (res && res.data) {
          updateAppData(res.data);
        }
        // let validationData = await validateProperty('plaidToken');

        // if (validationData.data && validationData.data.errors) {
        //   if (validationData.data.errors.length) {
        //     validationData.data.errors.map((error) => {
        //       setError(error.message);
        //     });
        //   }
        // }
        // setLoading(false);
        setPlaidState('success');
      } catch (e) {
        console.error(e);
        // setLoading(false);
        errorEvent('Error API', e);
        setPlaidState('manual');
        NotificationManager.warning(
          "We could not retrieve your bank details using Plaid, let's try another method.",
          'Warning',
          10000
        );
      }
      handleContinue();
    },
    // eslint-disable-next-line
    [handleContinue, setLoading, updateAppData, setPlaidToken, setPlaidState]
  );

  const onExit = useCallback(
    (error, metadata) => {
      // send public_token to server
      setCloseTimes((closeTimes) => closeTimes + 1);
      if (error && error.error_message) {
        console.log(error, metadata);
        setError(error.error_message);
      }
      setPlaidState('failure');
    },
    [setError, setPlaidState]
  );

  useEffect(() => {
    if (closeTimes > plaidNbOfRetries) {
      handleContinue();
    }
  }, [closeTimes]);

  const config = {
    token,
    onSuccess,
    onExit,
    receivedRedirectUri,
    // onEvent
  };

  const { open, ready } = usePlaidLink(config);

  // automatically reinitialize Link
  useEffect(() => {
    if (ready && receivedRedirectUri) {
      open();
      cookie.remove('oauth_state_id', { path: '/' });
      cookie.remove('receivedRedirectUri', { path: '/' });
    }
  }, [receivedRedirectUri, ready, open]);

  return receivedRedirectUri ? (
    <></>
  ) : (
    <button className={buttonClassName} onClick={() => open()} disabled={!ready}>
      {buttonText}
    </button>
  );
};

export default CustomPlaidLink;
